import { Loader } from "components";
import { useTokenAuth } from "hooks";
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { ProtectedRouteProps } from "type";

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectTo = "/unauthorized",
}) => {
  const { isValidating, isValid, error } = useTokenAuth();
  const shareId = new URLSearchParams(window.location.search).get("id");
  // Show loader while validating token
  if (isValidating) {
    return <Loader />;
  }
  // Check for share token validation first
  if (shareId) {
    // If there's a share ID, validate based on share token
    // isValid can be: null (no validation), true (valid), false (invalid)
    if (error || isValid === false) {
      return <Navigate to={redirectTo + `?id=${shareId}`} replace />;
    }
    // If isValid is null, it means validation hasn't completed yet
    if (isValid === null) {
      return <Loader />;
    }
  } else {
    return <Navigate to={redirectTo + `?id=${shareId}`} replace />;
  }
  // If children are provided, render them, otherwise render nested routes
  return children ? children : <Outlet />;
};
export default ProtectedRoute;
